interface TellMeMoreButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
}

export default function TellMeMoreButton({ label, onClick, className }: TellMeMoreButtonProps) {
  return (
    <button
      className={`tmm-btn${className ? ` ${className}` : ""}`}
      onClick={onClick}
    >
      <span className="svg-icon svg-ai"></span>
      <span className="tmm-btn-text">{label}</span>
    </button>
  );
}
